import React from 'react'
import './Language.css';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

function Language() {
  const { t, i18n } = useTranslation();

  const handleChange = (e) => {
    i18n.changeLanguage(e.target?.value);
  }

  return (
    <Form.Group className="mb-32 positionRelative" controlId="formGroupLanguage">
      <Form.Label>{t('LABEL_LANGUAGE_SELECT')}</Form.Label>
      <Form.Select onChange={handleChange} className="toggleBtn" value={i18n?.language}>
        <option value="en">{t('TEXT_LANGUAGE_SELECT_OPTION_EN')}</option>
        <option value="es">{t('TEXT_LANGUAGE_SELECT_OPTION_SPN')}</option>
        <option value="cr">{t('TEXT_LANGUAGE_SELECT_OPTION_CREOLE')}</option>
      </Form.Select>
      <div className="triangleDown"></div>
    </Form.Group>
  )
}

export default Language;